
<script setup>
import { ref, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { transactionBatchAPI } from './service/api.js';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Button from 'primevue/button';
import { formatCurrency } from '@/util/format'


const route = useRoute();

const transactions = ref([])
const batchTotal = ref(0);

const fetchTransactionBatchDetail = async (id) => {
    try {
        const response = await transactionBatchAPI.getTransactionDetail(id);
        transactions.value = response.data || [];
        batchTotal.value = transactions.value.reduce((sum, transaction) => sum + (transaction.amount || 0), 0);
    } catch (error) {
        console.error('Error fetching bank file detail:', error);
    }
}

const downloadTransactionBatchDetailFile = (id) => {

  transactionBatchAPI.downloadTransactionBatchDetail(id).then((response) => {
      // Get the filename from the Content-Disposition header
      const disposition = response.headers['content-disposition'];

      let filename = 'file.csv'; // Default filename

      if (disposition && disposition.indexOf('attachment') !== -1) {
          const matches = disposition.match(/filename="?(.+)"?/);
          if (matches[1]) {
              filename = matches[1];
          }
      }

      // Create a URL for the Blob and initiate the download
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename); // Use the filename from the header
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link); // Clean up the DOM
  })
  .catch((error) => {
      console.error('Error downloading the file', error);
  });
}

onMounted(() => {
    const bfid = route.params.code;
    fetchTransactionBatchDetail(bfid);
});

</script>
<template>
    <div class="app-container">
        <header class="app-header">
            <div class="header-logo"><img src="/logo.png" width="200" height="50"/></div>
        </header>
        <div class="app-content">
            <DataTable :value="transactions" :rows="25" paginator :rowsPerPageOptions="[25, 50, 100]" :responsiveLayout="'scroll'">
                <template #header>
                    <div class="flex justify-between">
                        <h3>Payment File Details</h3>
                        <Button @click="downloadTransactionBatchDetailFile($route.params.code)" class="p-button p-component p-button-outlined">
                            <span class="pi pi-download"/>
                            Download CSV
                        </Button>
                    </div>
                    <br />
                    <div><h3>Total Amount: <b>{{ formatCurrency(batchTotal) }}</b></h3></div>
                    <div v-if="transactions.length" class="batch-summary">
                        <p><strong>Paid Date:</strong> {{ transactions[0].paid_date || '—' }}</p>
                        <p><strong>Confirmation Number:</strong> {{ transactions[0].confirmation_number || '—' }}</p>
                    </div>
                </template>
                <Column field="claim_number" header="Claim Number"></Column>
                <Column field="invoice_date" header="Invoice Date"></Column>
                <Column field="payment_amount" header="Amount">
                    <template #body="slotProps">
                        {{ formatCurrency(slotProps.data.amount) }}
                    </template>
                </Column>
                <Column field="invoice_number" header="Document Control Number"></Column>
                <Column field="vendor_invoice_number" header="Vendor's Invoice Number"></Column>
                <Column field="date_from" header="From Date"></Column>
                <Column field="date_to" header="Through Date"></Column>
                <Column field="paid_date" header="Paid Date"></Column>
                <Column field="confirmation_number" header="Confirmation Number"></Column>
                <Column field="eor_link" header="EOR Link">
                    <template #body="slotProps">
                        <a v-if="slotProps.data.eor_link" :href="slotProps.data.eor_link" target="_blank">View EOR</a>
                        <span v-else>No EOR</span>
                    </template>
                </Column>
            </DataTable>

        </div>
    </div>
</template>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

.batch-summary {
  text-align: left;
  margin: 1rem 0;
  padding: 0.75rem 1rem;
  background: #f5f5f5;
  border-radius: 6px;
}

.batch-summary p {
  margin: 0.25rem 0;
}
</style>
